/**
 * ¿Alcanza la app a la API de su ambiente, y la API a la base?
 *
 * Es la comprobación de la fase 1: que `qaapp` esté publicada no basta, tiene
 * que estar hablando con la API de QA por el mismo origen. Si Nginx no
 * reenvía /api/, la petición cae en el `try_files` y vuelve index.html con
 * un 200: por eso se exige JSON y no sólo una respuesta correcta.
 */
export type Salud =
  | { estado: 'comprobando' }
  | { estado: 'ok' }
  | { estado: 'sin_base' }
  | { estado: 'sin_api'; detalle: string };

export async function comprobarSalud(senal?: AbortSignal): Promise<Salud> {
  try {
    const respuesta = await fetch('/api/v1/salud', {
      headers: { Accept: 'application/json' },
      signal: senal,
    });
    if (!respuesta.ok) {
      return { estado: 'sin_api', detalle: `La API respondió ${respuesta.status}.` };
    }
    const tipo = respuesta.headers.get('content-type') ?? '';
    if (!tipo.includes('json')) {
      return {
        estado: 'sin_api',
        detalle: 'Llegó una página en vez de la API: el servidor no está reenviando /api/.',
      };
    }
    const cuerpo: unknown = await respuesta.json();
    const base = (cuerpo as { base?: unknown } | null)?.base;
    return base === 'ok' ? { estado: 'ok' } : { estado: 'sin_base' };
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw error;
    return { estado: 'sin_api', detalle: 'Sin conexión con el servidor.' };
  }
}
